// @ts-nocheck
(function () {
  'use strict';

  const HOST_STYLES = `
    /* Constrain the form host + every wrapper up to the section root,
       so nothing exceeds the viewport on mobile. */
    shopify-forms-embed,
    [id^="shopify-block-"][class*="shopify-app-block"],
    [data-form-root],
    [data-forms-id] {
      --inline-container-max-width: 900px !important;
      --container-max-w: 900px !important;
      max-width: min(900px, 100%) !important;
      width: 100% !important;
      margin-left: auto !important;
      margin-right: auto !important;
      display: block !important;
      box-sizing: border-box !important;
    }
  `;

  const STYLES = `
    /* Host-internal spacing reset to avoid mobile overflow */
    :host {
      --app-embed-padding-x: 0 !important;
      --app-embed-padding-y: 0 !important;
      --spacing-size-x: 0 !important;
      --container-max-w: 100% !important;
      --inline-container-max-width: 100% !important;
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
      box-sizing: border-box !important;
    }

    /* Reset ALL form descendants to safe sizing */
    *, *::before, *::after {
      box-sizing: border-box !important;
      min-width: 0 !important;
      max-width: 100% !important;
    }

    /* The shadow DOM router/container chain */
    [class*="_container_"],
    [data-testid="app-router"],
    [data-sizing="form-wrapper"],
    [class*="_inline_"],
    [class*="_grid_"],
    [class*="_gridItem_"],
    [class*="_gridItemContent_"] {
      width: 100% !important;
      max-width: 100% !important;
      padding: 0 !important;
      box-sizing: border-box !important;
    }

    /* Container: no card chrome, single grid column, vertical breathing room */
    [class*="_formContainer_"] {
      background: transparent !important;
      box-shadow: none !important;
      border: 0 !important;
      padding: 48px 0 !important;
      max-width: 100% !important;
      width: 100% !important;
      margin: 0 auto !important;
      grid-template-columns: 1fr !important;
      box-sizing: border-box !important;
    }
    [class*="_gridItemContent_"] {
      width: 100% !important;
      padding: 0 !important;
    }
    [class*="_imageLoading_"] {
      display: none !important;
    }

    /* Heading */
    [class*="_formHeader_"] {
      text-align: center !important;
      padding-top: 32px !important;
      padding-bottom: 32px !important;
      margin: 0 !important;
    }
    [class*="_textHeading_"] {
      font-family: universe, sans-serif !important;
      font-size: 20px !important;
      font-style: normal !important;
      font-variation-settings: "slnt" 0 !important;
      font-weight: 700 !important;
      text-align: center !important;
      letter-spacing: 0.12em !important;
      text-transform: uppercase !important;
      line-height: 1.2 !important;
      margin: 0 !important;
    }

    /* Form: CSS grid with named auto-flow. Errors are taken OUT of grid
       flow via absolute positioning so they never disturb the rhythm. */
    [class*="_formFieldset_"] {
      display: grid !important;
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      column-gap: 24px !important;
      row-gap: 36px !important;
      align-items: end !important;
      width: 100% !important;
      max-width: 100% !important;
      box-sizing: border-box !important;
    }
    @media (max-width: 749px) {
      [class*="_formFieldset_"] {
        grid-template-columns: 1fr !important;
        row-gap: 24px !important;
      }
    }

    /* Each field occupies one column */
    [class*="_formFieldContainer_"],
    [class*="_selectContainer_"],
    [class*="_formPhoneInputContainer_"],
    [class*="_formFileInput_"] {
      grid-column: span 1 !important;
      position: relative !important;
      min-width: 0 !important;
      max-width: 100% !important;
      box-sizing: border-box !important;
      align-self: baseline !important;
    }

    /* The empty <shop-lead-capture> wrapper takes column 2 of row 1,
       leaving the first real field alone in column 1 of row 1.
       We force it to be visible-but-empty (height of a field). */
    [class*="_formFieldset_"] > div:has(shop-lead-capture) {
      grid-column: 2 / 3 !important;
      grid-row: 1 !important;
      visibility: hidden !important;
      min-height: 1px !important;
      margin: 0 !important;
      padding: 0 !important;
    }
    @media (max-width: 749px) {
      /* On mobile (single column) just hide the empty cell entirely. */
      [class*="_formFieldset_"] > div:has(shop-lead-capture) {
        display: none !important;
      }
    }

    /* Force visual order: label, then input, then error.
       DOM is input/label (and sometimes followed by error). */
    [class*="_formFieldContainer_"] {
      display: flex !important;
      flex-direction: column !important;
      gap: 8px !important;
    }
    [class*="_formFieldContainer_"] [class*="_formInputFieldLabel_"] {
      order: 1 !important;
    }
    [class*="_formFieldContainer_"] [class*="_formInputField_"],
    [class*="_formFieldContainer_"] [class*="_formPhoneInputField_"] {
      order: 2 !important;
    }
    [class*="_formFieldContainer_"] [class*="_formError_"] {
      order: 3 !important;
    }

    /* Submit + disclaimer span full row */
    [class*="_formSubmitButton_"],
    [class*="_formDisclaimer_"] {
      grid-column: 1 / -1 !important;
    }

    /* Error messages — when JS moves them inside their field container,
       they render as a small red text below the input. */
    [class*="_formError_"] {
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
      font-size: 0.75rem !important;
      color: #c0392b !important;
      line-height: 1.4 !important;
      box-sizing: border-box !important;
    }
    /* Fallback: if the error is still a grid-direct sibling (JS didn't move it),
       hide it from the grid layout so it doesn't break the column rhythm. */
    [class*="_formFieldset_"] > [class*="_formError_"] {
      display: none !important;
    }
    /* Inline file-input errors (different class hash) live INSIDE the
       file-input container so they don't disrupt the row. */
    [class*="_formFileInput_"] [class*="_error_"] {
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
      font-size: 0.75rem !important;
      color: #c0392b !important;
      margin: 6px 0 0 0 !important;
      padding: 0 !important;
      line-height: 1.4 !important;
    }

    /* Labels above field (uppercase tracking) */
    [class*="_formInputFieldLabel_"],
    [class*="_selectContainer_"] [class*="_label_"],
    [class*="_formFileInput_"] > p {
      position: static !important;
      transform: none !important;
      top: auto !important;
      left: auto !important;
      display: block !important;
      font-family: var(--font-heading--family, sans-serif) !important;
      font-size: 0.75rem !important;
      font-weight: 500 !important;
      letter-spacing: 0.12em !important;
      text-transform: uppercase !important;
      color: #1a1a1a !important;
      margin: 0 !important;
      padding: 0 !important;
      background: transparent !important;
      pointer-events: auto !important;
    }

    /* Inputs */
    [class*="_formInputField_"],
    [class*="_formPhoneInputField_"] {
      width: 100% !important;
      min-width: 0 !important;
      max-width: 100% !important;
      box-sizing: border-box !important;
      padding: 14px 16px !important;
      border: 1px solid #d0d0d0 !important;
      border-radius: 0 !important;
      background: #fff !important;
      font-family: var(--font-body--family, sans-serif) !important;
      font-size: 0.95rem !important;
      box-shadow: none !important;
      outline: none !important;
      color: #1a1a1a !important;
    }
    [class*="_formInputField_"]::placeholder,
    [class*="_formPhoneInputField_"]::placeholder {
      color: #9a9a9a !important;
      opacity: 1 !important;
    }
    [class*="_formInputField_"]:focus,
    [class*="_formPhoneInputField_"]:focus {
      border-color: #1a1a1a !important;
      box-shadow: none !important;
    }

    /* Select toggle button (Civilité, Métier, etc.) */
    [class*="_selectToggle_"] {
      width: 100% !important;
      min-width: 0 !important;
      max-width: 100% !important;
      box-sizing: border-box !important;
      padding: 14px 16px !important;
      border: 1px solid #d0d0d0 !important;
      border-radius: 0 !important;
      background: #fff !important;
      box-shadow: none !important;
      font-family: var(--font-body--family, sans-serif) !important;
      font-size: 0.95rem !important;
      text-align: left !important;
      color: #1a1a1a !important;
      display: flex !important;
      justify-content: space-between !important;
      align-items: center !important;
      min-height: 50px !important;
    }
    [class*="_selectToggle_"]:focus,
    [class*="_selectToggle_"]:focus-visible,
    [class*="_selectToggle_"]:hover {
      box-shadow: none !important;
      outline: none !important;
    }
    [class*="_selectToggleText_"] {
      color: #9a9a9a !important;
    }
    [class*="_selectToggleText_"]:not(:empty) {
      color: #1a1a1a !important;
    }

    /* Phone input group: keep flag selector + number in one row */
    [class*="_formPhoneInputContainer_"] {
      display: flex !important;
      gap: 8px !important;
      align-items: flex-end !important;
    }
    [class*="_formPhoneInputContainer_"] .phone-country-selector {
      flex: 0 0 auto !important;
    }
    [class*="_formPhoneInputContainer_"] .phone-country-selector [class*="_selectToggle_"] {
      min-width: 80px !important;
      min-height: 48.5px !important;
    }
    [class*="_formPhoneInputContainer_"] [class*="_formFieldContainer_"] {
      flex: 1 1 auto !important;
    }
    /* When the phone number field shows an error, its column grows by the
       error text's height. flex-end would then drop the country selector to
       align with the bottom of the error. Push the selector up by that height
       (error line-height ≈ 24px) so it stays aligned with the input. */
    [class*="_formPhoneInputContainer_"]:has([class*="_withError_"]) .phone-country-selector {
      margin-bottom: 24px !important;
    }

    /* File inputs */
    [class*="_formFileInputField_"] {
      width: 100% !important;
      box-sizing: border-box !important;
      padding: 18px 16px !important;
      border: 1px dashed #c0c0c0 !important;
      border-radius: 0 !important;
      background: #fff !important;
      text-align: left !important;
      cursor: pointer !important;
      display: flex !important;
      align-items: center !important;
      gap: 12px !important;
    }
    [class*="_formFileInputField_"]:hover {
      border-color: #1a1a1a !important;
    }
    [class*="_formFileInputButton_"] {
      font-family: var(--font-heading--family, sans-serif) !important;
      font-size: 0.75rem !important;
      font-weight: 500 !important;
      letter-spacing: 0.12em !important;
      text-transform: uppercase !important;
      color: #555 !important;
      margin: 0 !important;
    }

    /* Submit button: matches the theme's primary .button style but forced black. */
    [class*="_formSubmitButton_"] {
      grid-column: 1 / -1 !important;
      justify-self: center !important;
      width: fit-content !important;
      min-width: 280px !important;
      display: grid !important;
      align-content: center !important;
      text-align: center !important;
      text-decoration: none !important;
      appearance: none !important;
      background-color: #3d4d55 !important;
      color: var(--color-primary-button-text) !important;
      border: none !important;
      box-shadow: inset 0 0 0 var(--style-border-width-primary, 0) #3d4d55 !important;
      border-radius: var(--style-border-radius-buttons-primary, 0) !important;
      font-family: 'universe', sans-serif !important;
      font-style: var(--font-paragraph--style, normal) !important;
      font-size: var(--font-paragraph--size, 1rem) !important;
      font-weight: 400 !important;
      line-height: var(--font-paragraph--line-height, 1.5) !important;
      letter-spacing: normal !important;
      text-transform: var(--button-text-case-primary, none) !important;
      padding-block: var(--button-padding-block, 16px) !important;
      padding-inline: var(--button-padding-inline, 32px) !important;
      margin: 16px 0 0 0 !important;
      cursor: pointer !important;
      transition: color var(--animation-speed, 0.2s) var(--animation-easing, ease),
        background-color var(--animation-speed, 0.2s) var(--animation-easing, ease),
        box-shadow var(--animation-speed, 0.2s) var(--animation-easing, ease) !important;
    }
    [class*="_formSubmitButton_"]:hover {
      background-color: #2d3a40 !important;
      opacity: 1 !important;
    }

    /* Disclaimer */
    [class*="_formDisclaimer_"] {
      margin-top: 8px !important;
      padding-top: 24px !important;
      border-top: 1px solid #e5e5e5 !important;
      font-family: var(--font-body--family, sans-serif) !important;
      font-size: 0.85rem !important;
      color: #555 !important;
      text-align: center !important;
    }
    [class*="_formDisclaimer_"] p {
      text-align: center !important;
      margin: 0 !important;
    }
    [class*="_formDisclaimer_"] a {
      color: #1a1a1a !important;
      text-decoration: underline !important;
    }

    /* Hide the empty image grid item */
    [class*="_noImage_"] [class*="_gridItem_"]:first-child {
      display: none !important;
    }

    /* Required-field marker — appended via JS to each required field's
       container/label. Renders a red asterisk after the label text. */
    [class*="_formInputFieldLabel_"][data-required="1"]::after,
    [class*="_selectContainer_"][data-required="1"] [class*="_label_"]::after,
    [class*="_formFileInput_"][data-required="1"] > p::after {
      content: " *";
      color: #c0392b !important;
      font-weight: 700 !important;
    }
  `;

  // Fields we treat as required (hardcoded — the Forms app does not expose
  // requiredness in the rendered DOM; form is novalidate + no required attrs).
  // Matched by stable input id / select aria-controls, never by class hash.
  const REQUIRED_INPUT_IDS = ['last_name', 'first_name', 'email', 'phone_number'];
  const REQUIRED_SELECT_CONTROLS = ['custom#mtier_vis-selector-dropdown'];
  const REQUIRED_FILE_LABEL_IDS = ['custom#votre_cv-label'];

  function injectIntoShadowRoot(shadowRoot) {
    if (!shadowRoot || shadowRoot.querySelector('style[data-c-form-styler]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-c-form-styler', '');
    style.textContent = STYLES;
    shadowRoot.appendChild(style);
  }

  function injectHostStyles() {
    if (document.querySelector('style[data-c-form-styler-host]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-c-form-styler-host', '');
    style.textContent = HOST_STYLES;
    document.head.appendChild(style);
  }

  // Move each error <output> into the preceding field container so it
  // becomes a child instead of a grid sibling. The CSS then renders it
  // as small red text below the input without breaking the 2-column grid.
  function relocateErrors(shadowRoot) {
    const errors = shadowRoot.querySelectorAll('output[class*="_formError_"]');
    errors.forEach((err) => {
      if (err.dataset.relocated === '1') return;
      const prev = err.previousElementSibling;
      if (prev && /_formFieldContainer_|_selectContainer_|_formPhoneInputContainer_/.test(prev.className)) {
        prev.appendChild(err);
        err.dataset.relocated = '1';
      }
    });
  }

  // Mark required fields by stable id / aria-controls (not class hash) so CSS
  // can render an asterisk on their label.
  function markRequired(shadowRoot) {
    REQUIRED_INPUT_IDS.forEach((id) => {
      const input = shadowRoot.getElementById(id);
      const label = input && input.parentElement
        ? input.parentElement.querySelector('[class*="_formInputFieldLabel_"]')
        : null;
      if (label) label.setAttribute('data-required', '1');
    });

    REQUIRED_SELECT_CONTROLS.forEach((control) => {
      const toggle = shadowRoot.querySelector('[aria-controls="' + control + '"]');
      const container = toggle ? toggle.closest('[class*="_selectContainer_"]') : null;
      if (container) container.setAttribute('data-required', '1');
    });

    REQUIRED_FILE_LABEL_IDS.forEach((id) => {
      const btn = shadowRoot.getElementById(id);
      const container = btn ? btn.closest('[class*="_formFileInput_"]') : null;
      if (container) container.setAttribute('data-required', '1');
    });
  }

  function tryStyleAll() {
    injectHostStyles();
    document.querySelectorAll('shopify-forms-embed').forEach((host) => {
      if (host.shadowRoot) {
        injectIntoShadowRoot(host.shadowRoot);
        relocateErrors(host.shadowRoot);
        markRequired(host.shadowRoot);
      }
    });
  }

  // Initial pass
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryStyleAll);
  } else {
    tryStyleAll();
  }

  // Observe for late-mounted forms (Section Rendering API, editor re-render)
  const observer = new MutationObserver(tryStyleAll);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  // Also observe inside each shadow root so we catch errors that appear
  // on form submit (which mutates shadow DOM, not light DOM).
  const observedShadowRoots = new WeakSet();
  function attachShadowObservers() {
    document.querySelectorAll('shopify-forms-embed').forEach((host) => {
      if (!host.shadowRoot || observedShadowRoots.has(host.shadowRoot)) return;
      observedShadowRoots.add(host.shadowRoot);
      const shadowObserver = new MutationObserver(() => {
        relocateErrors(host.shadowRoot);
      });
      shadowObserver.observe(host.shadowRoot, { childList: true, subtree: true });
    });
  }
  setInterval(attachShadowObservers, 500);

  // Retry shortly after load in case shadow root attaches after we first looked
  let retries = 0;
  const retryTimer = setInterval(() => {
    tryStyleAll();
    if (++retries >= 10) clearInterval(retryTimer);
  }, 300);
})();
